// Central API configuration for local development & server deployment
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5005';

export default API_BASE_URL;
